<!--<h4 class="fw-bold py-3 mb-2">Grid Datasets and Visualization</h4>
<hr class="container-m-nx border-light my-0" />-->  

  <div class="row mt-2 height100">
    <div class="col-lg-12 col-xl-4">
      <div class="card mb-2 ms-2 cardContainer" *ngIf="isFetrapiMember">
        <div class="card-header with-elements">
          <span class="card-header-title me-2">Staging Grid</span>
          <div class="card-header-elements">
            <label class="switcher switcher-sm me-0">
              <input class="switcher-input" type="checkbox" [checked]="isStagingChecked" (change)="ToggleStaging($event)">
              <span class="switcher-indicator">
                <span class="switcher-yes"></span>
                <span class="switcher-no"></span>
              </span>
            </label>
          </div>
        </div>

        <div class="card-body noPbPt" *ngIf="isLoaded">
          <div class="mb-3" *ngIf="allowUpload">
            <div><label for="file"><b>Submit new Grid dataset</b></label></div>
            <div class="fileContainer" *ngIf="!isUploading">
              <label class="btn btn-default">
                Upload zip file
                <input type="file" hidden id="file" (change)="handleFileInput($event)" />
              </label>
              <button *ngIf="fileToUpload" hidden class="btn btn-default" type='button' (click)="uploadDataset()">Upload</button>
            </div>
            <div *ngIf="isUploading">
              <div class="spinner-border" role="status">
                <span class="visually-hidden">Uploading file...</span>
              </div>
              <label>Uploading file...</label>
            </div>
          </div>
          <div class="mb-3" *ngIf="stagingDataset"> <!-- && loadedStaging"> -->
            <label><b>Dataset:</b></label>
            <label class="dsId">{{stagingDataset.datasetId}}</label>
            <br />
            <label><b>Uploaded:</b></label>
            <label>{{appService.utcToLocal(stagingDataset.dateTimeCreated)}}</label>
            <br />
            <label><b>Status:</b></label>
            <label>{{stagingDataset.statusCode}}</label>
            <br />
            <div class="btn-group mb-2" *ngIf="stagingDataset.statusCode == 'ValidationSucceeded'">
              <button class="btn btn-default" type="button" (click)="approveDataset(stagingDataset.datasetId)">Approve</button>
              <button class="btn btn-default" type="button" (click)="rejectDataset(stagingDataset.datasetId)">Reject</button>
            </div>
            <br />
      
              <button class="btn btn-default" type='button' *ngIf="stagingDataset.hasValidationReport" (click)="downloadValidationReport(stagingDataset.datasetId)" title="{{stagingDataset ? stagingDataset.datasetId : ''}}">Validation Report</button>
              <button class="btn btn-default" type='button' *ngIf="stagingDataset.hasValidationReport" (click)="downloadDataset(stagingDataset.datasetId)" title="{{stagingDataset ? stagingDataset.datasetId : ''}}">Download</button>
              <button class="btn btn-default" type="button" *ngIf="stagingKLIMBufferDataset" (click)="downloadDataset(stagingKLIMBufferDataset.datasetId)" title="{{stagingKLIMBufferDataset ? stagingKLIMBufferDataset.datasetId : ''}}">Download KLIM Buffer</button>
       
          </div>
        </div>
        
        <div class="spinnerContainer" *ngIf="!isLoaded">
          <div class="spinner-border mt-4 mb-4" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <div class="card mb-2 ms-2 cardContainer" *ngIf="isFetrapiMember">
        <div class="card-header with-elements">
          <span class="card-header-title me-2">Production Grid</span>
          <div class="card-header-elements">
            <label class="switcher switcher-sm me-0">
              <input class="switcher-input" type="checkbox" [checked]="isProductionChecked" (change)="ToggleProduction($event)">
              <span class="switcher-indicator">
                <span class="switcher-yes"></span>
                <span class="switcher-no"></span>
              </span>
            </label>
          </div>
        </div>

        <div class="card-body noPbPt" *ngIf="isLoaded">  <!-- && loadedProduction"> -->
          <div class="mb-3" *ngIf="productionDataset">
            <label><b>Dataset:</b></label>
            <label class="dsId">{{productionDataset.datasetId}}</label>
            <br />
            <label><b>Uploaded:</b></label>
            <label>{{appService.utcToLocal(productionDataset.dateTimeCreated)}}</label>
            <div class="mb-3">
              <label><b>Status:</b></label>
              <label>{{productionDataset.statusCode}}</label>
              <button class="ms-3 btn btn-default" type='button' *ngIf="productionDataset.statusCode == FetrapiEnums.DatasetStatusCode.ConfirmationRequired" (click)="confirmDataset(productionDataset.datasetId)" title="{{productionDataset ? productionDataset.datasetId : ''}}">Confirm Dataset</button>
            </div>
            <button class="btn btn-default" type='button' *ngIf="productionDataset" (click)="downloadValidationReport(productionDataset.datasetId)" title="{{productionDataset ? productionDataset.datasetId : ''}}">Validation Report</button>
            <button class="btn btn-default" type='button' *ngIf="productionDataset" (click)="downloadDataset(productionDataset.datasetId)" title="{{productionDataset ? productionDataset.datasetId : ''}}">Download</button>
            <button class="btn btn-default" type="button" *ngIf="productionKLIMBufferDataset" (click)="downloadDataset(productionKLIMBufferDataset.datasetId)" title="{{productionKLIMBufferDataset ? productionKLIMBufferDataset.datasetId : ''}}">Download KLIM Buffer</button>
          </div>
        </div>
        <div class="spinnerContainer" *ngIf="!isLoaded">
          <div class="spinner-border mt-4 mb-4" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>

      <div class="card mb-2 ms-2 cardContainer">
        <div class="card-header with-elements">
          <span class="card-header-title me-2">Consolidated Grid</span>
          <div class="card-header-elements">
            <label class="switcher switcher-sm me-0">
              <input class="switcher-input" type="checkbox" [checked]="isConsolidationChecked" (change)="ToggleConsolidation()">
              <span class="switcher-indicator">
                <span class="switcher-yes"></span>
                <span class="switcher-no"></span>
              </span>
            </label>
          </div>
        </div>
        <div class="card-body noPbPt" *ngIf="isLoaded && consolidateDataset">
          <div class="mb-3">
            <label><b>Dataset:</b></label>
            <label class="dsId">{{consolidateDataset.datasetId}}</label>
            <br />
            <label><b>Uploaded:</b></label>
            <label>{{appService.utcToLocal(consolidateDataset.dateTimeCreated)}}</label>
            <br />
            <label><b>Status:</b></label>
            <label>{{consolidateDataset.statusCode}}</label>
            <div> 
                <label><b>Download</b></label><br />
                <button type='button' class="btn btn-default" *ngIf="consolidateDataset" (click)="downloadDataset(consolidateDataset.datasetId)" title="{{consolidateDataset ? consolidateDataset.datasetId : ''}}">Fetrapi Format</button>
                <button type='button' class="btn btn-default" *ngIf="adcrExportDataset" (click)="downloadDataset(adcrExportDataset.datasetId)" title="{{adcrExportDataset ? adcrExportDataset.datasetId : ''}}">ADCR Format</button>
                <button type='button' class="btn btn-default" *ngIf="chapter3ExportDataset" (click)="downloadDataset(chapter3ExportDataset.datasetId)" title="{{chapter3ExportDataset ? chapter3ExportDataset.datasetId : ''}}">Ch III Format</button>
            </div>
          </div>
        </div>
        <div class="spinnerContainer" *ngIf="!isLoaded">
          <div class="spinner-border mt-4 mb-4" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-xl-8" style="padding-right:20px">
      <div class="card m-0 mapContainer">
        <div id="map"></div>
      </div>
    </div>
  </div>
